import * as React from 'react';
import type {IEventTemplate} from '../../../types/IEventTemplate';
import type {SequenceItem} from '../../../types/IEventTemplateMetadata';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {
  CollapsibleCard,
  CollapsibleCardContent,
} from '@spaced-out/ui-design-system/lib/components/CollapsibleCard';
import {Chip} from '@spaced-out/ui-design-system/lib/components/Chip';
import {SequenceDayItem} from './sequence-day-item';
import {useBookingMachine} from '../../../hooks/useBookingMachine';
import {selectFormattedSelectedDateForDay} from '../../../selectors/booking-selector';
import {useSelector} from '@xstate/react';
import {useRootMachine} from '../../../hooks/useRootMachine';
import {selectTimezone} from '../../../selectors/timezoneSelectors';
import css from './sequential-booking-info.css';
import {SubTitleSmall} from '@spaced-out/ui-design-system/lib/components/Text';


interface DayCardProps {
  dayNumber: number;
  sequenceDay: SequenceItem;
  eventTemplate: IEventTemplate;
  index: number;
}

export const DayCard = ({
  dayNumber,
  sequenceDay,
  eventTemplate,
  index,
}: DayCardProps) => {
  const {t, language} = useLabelTranslation();
  const {bookingActor} = useBookingMachine();
  const {rootActor} = useRootMachine();
  const timezone = useSelector(rootActor, selectTimezone);

  const formattedDate = useSelector(bookingActor, (state) =>
    selectFormattedSelectedDateForDay(
      state,
      dayNumber,
      timezone || '',
      language,
    ),
  );

  const ItemTitleContent = () => (
    <div className={css.itemTitleContent}>
      {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
      <SubTitleSmall>{`${t('Day', 'Day')} ${dayNumber}`}</SubTitleSmall>
      {formattedDate && (
        <Chip semantic="primary" size="medium">
          {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
          {formattedDate}
        </Chip>
      )}
    </div>
  );

  return (
    <CollapsibleCard
      isOpen={true}
      classNames={{
        wrapper: css.collapsibleCardWrapper,
      }}
      key={`day-${index}`}
      paddingSize="small"
      title={<ItemTitleContent />}
    >
      <CollapsibleCardContent className={css.sequenceDayContent}>
        <SequenceDayItem
          sequenceDay={sequenceDay}
          eventTemplate={eventTemplate}
        />
      </CollapsibleCardContent>
    </CollapsibleCard>
  );
};
